<div [class]="styleClass">
  <app-count-box-indicator styleClass="w-4" text="im Altas verfügbar" />
  <app-count-box-layer-type styleClass="w-4" text="im Altas verfügbar" />
  <app-count-box-data-layer styleClass="w-4" text="im Altas verfügbar" />
  <app-count-box-poi styleClass="w-4" text="im Altas verfügbar" />
  <app-count-box-data styleClass="w-4" text="im Altas verfügbar" />
</div>
